import { IBaseIconProps } from "./IBaseIconProps";

export const BurgerMenuIcon = ({
  color = "#fff",
  backgroundColor,
}: IBaseIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 100 125"
      enableBackground="new 0 0 100 100"
      fill={color}
    >
      <path d="M80.384,27.779c1.464-1.171,0.636-3.533-1.239-3.533H20.856c-1.875,0-2.703,2.361-1.239,3.533l5.041,4.033  c0.352,0.281,0.789,0.435,1.239,0.435h48.207c0.45,0,0.887-0.153,1.239-0.435L80.384,27.779z" />
      <path d="M27.185,46c-1.096,0-1.984,0.888-1.984,1.984v4.033c0,1.096,0.888,1.984,1.984,1.984h45.631  c1.096,0,1.984-0.888,1.984-1.984v-4.033c0-1.096-0.888-1.984-1.984-1.984H27.185z" />
      <path d="M20.856,75.753h58.289c1.875,0,2.703-2.361,1.239-3.533l-5.041-4.033c-0.352-0.281-0.789-0.435-1.239-0.435H25.897  c-0.45,0-0.887,0.153-1.239,0.435l-5.041,4.033C18.152,73.392,18.98,75.753,20.856,75.753z" />
    </svg>
  );
};
